<template>
  <div class="honor">
    <div class="cert-container">
      <!-- 左图标 -->
      <img src="../../assets/home/pre.png" @click="last" class="control-img lastImg">

      <!-- 动态渲染当前页的图片 -->
<!--      <div-->
<!--          class="cert-item"-->
<!--          v-for="(item, index) in getCurrentItems"-->
<!--          :key="item.Id"-->
<!--          @mouseover="highlightItem(index)"-->
<!--          @mouseout="resetHighlight"-->
<!--          :class="{ 'highlight': highlightedIndex === index }"-->
<!--      >-->
<!--        <img :src="item.src" :alt="item.name">-->
<!--        <div class="cert-title">{{ item.name }}</div>-->
<!--      </div>-->
      <div class="cert-container-box">
        <div class="cert-item"
             v-cloak
             v-for="(item, index) in getCurrentItems"
             :key="item.Id"
             @mouseover="highlightItem(index)"
             @mouseout="resetHighlight"
             :class="{ 'highlight': highlightedIndex === index }"
        >
          <div v-if="!item.loaded" class="image-placeholder"></div>
          <img
              v-show="item.loaded"
              :src="item.src"
              :alt="item.name"
              @load="handleImageLoad"
              class="fade-in"
          >
          <div class="cert-title">{{ item.name }}</div>
        </div>
      </div>


      <!-- 右图标 -->
      <img src="../../assets/home/next.png" @click="next" class="control-img nextImg">
    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'honor',
  data() {
    return {
      // 原始数据
      originalHonor: [
        { Id: 1, src: require('@/assets/HONOR/new/12.jpg'), name: '安全生产标准化三级企业(轻工)' , loaded: false },
        { Id: 4, src: require('@/assets/HONOR/new/9.jpg'), name: '高新技术企业' , loaded: false },
        { Id: 5, src: require('@/assets/HONOR/new/8.jpg'), name: '通辽市"光彩之星"', loaded: false  },
        { Id: 6, src: require('@/assets/HONOR/new/7.jpg'), name: '科学技术协会' , loaded: false },
        { Id: 7, src: require('@/assets/HONOR/new/6.jpg'), name: '内蒙古肉牛产业协会理事单位' , loaded: false },
        { Id: 8, src: require('@/assets/HONOR/new/5.jpg'), name: '农牧业生产化重点龙头企业', loaded: false  },
        { Id: 9, src: require('@/assets/HONOR/new/4.jpg'), name: '农牧业生产化市级重点龙头企业' , loaded: false },
        { Id: 10, src: require('@/assets/HONOR/new/3.jpg'), name:'疫情防控先进集体', loaded: false },
        { Id: 11, src: require('@/assets/HONOR/new/2.jpg'), name: '专精特新中小企业' , loaded: false },
        { Id: 12, src: require('@/assets/HONOR/new/1.jpg'), name: '自治区企业研究开发中心' , loaded: false },
        { Id: 2, src: require('@/assets/HONOR/new/11.jpg'), name: '辽通市创新型中小企业' , loaded: false },
        { Id: 3, src: require('@/assets/HONOR/new/10.jpg'), name: '创新型中小企业', loaded: false  },
        { Id: 13, src: require('@/assets/HONOR/new/13.jpg'), name: '自治区战略性新兴产业发展支持项目' , loaded: false },
      ],
      currentHonorId: null,
      itemsPerPage: 3,
      isMobile: false,
      autoPlayInterval: null,
      autoPlayIntervalTime: 6000,
      manualToAutoDelay: 6000,
      isManualMode: false,
      highlightedIndex: null,
      isTransitioning: false, // 添加过渡状态标记
    };
  },
  computed: {
    ...mapState(["isPc"]),
    // 修改 honor 计算属性，为克隆数据生成新的 Id
    honor() {
      const originalLength = this.originalHonor.length;
      const maxId = Math.max(...this.originalHonor.map(item => item.Id));

      // 为前面的克隆数据生成新的 Id
      const frontClones = this.originalHonor.slice(-this.itemsPerPage).map((item, index) => ({
        ...item,
        Id: maxId + index + 1
      }));

      // 为后面的克隆数据生成新的 Id
      const backClones = this.originalHonor.slice(0, this.itemsPerPage).map((item, index) => ({
        ...item,
        Id: maxId + this.itemsPerPage + index + 1
      }));

      // 返回完整数组
      return [
        ...frontClones, // 前面的克隆数据
        ...this.originalHonor, // 原始数据
        ...backClones // 后面的克隆数据
      ];
    },
    sortedHonor() {
      return [...this.honor].sort((a, b) => a.Id - b.Id);
    },
    currentIndex() {
      return this.sortedHonor.findIndex(item => item.Id === this.currentHonorId);
    },
    getCurrentItems() {
      return this.sortedHonor.slice(this.currentIndex, this.currentIndex + this.itemsPerPage);
    },
  },
  watch: {
    isMobile(newVal) {
      if (newVal) {
        this.itemsPerPage = 1; // 移动端每页显示1张
      } else {
        this.itemsPerPage = 3; // 非移动端每页显示3张
      }
    },
    $route: {
      immediate: true,
      handler(to) {
        if (to.path.includes('/Talent/system')) {
          this.currentTab = 1;
        } else {
          this.currentTab = 0;
        }
      },
    }
  },
  methods: {
    // 修改 next 方法
    next() {
      if (this.isTransitioning) return;

      const idx = this.currentIndex;
      const nextIdx = idx + 1;
      const maxId = Math.max(...this.originalHonor.map(item => item.Id));

      // 检查是否需要切换到原始数据
      if (nextIdx >= this.originalHonor.length + this.itemsPerPage) {
        this.isTransitioning = true;
        // 无动画切换到对应的原始数据
        this.currentHonorId = this.sortedHonor[this.itemsPerPage].Id;
        this.$nextTick(() => {
          this.isTransitioning = false;
        });
      } else {
        this.currentHonorId = this.sortedHonor[nextIdx].Id;
      }

      this.resetAutoPlay();
    },
    // 修改 last 方法
    last() {
      if (this.isTransitioning) return;

      const idx = this.currentIndex;
      const prevIdx = idx - 1;
      const maxId = Math.max(...this.originalHonor.map(item => item.Id));

      // 检查是否需要切换到原始数据
      if (prevIdx < this.itemsPerPage) {
        this.isTransitioning = true;
        // 无动画切换到对应的原始数据
        this.currentHonorId = this.sortedHonor[this.originalHonor.length + this.itemsPerPage - 1].Id;
        this.$nextTick(() => {
          this.isTransitioning = false;
        });
      } else {
        this.currentHonorId = this.sortedHonor[prevIdx].Id;
      }

      this.resetAutoPlay();
    },
    // 修改 preloadImages 方法
    preloadImages() {
      this.honor.forEach(item => {
        const img = new Image();
        img.src = item.src;
        img.onload = () => {
          // 使用 Vue.set 来确保响应式更新
          this.$set(item, 'loaded', true);
        };
      });
    },
    // 修改 handleImageLoad 方法
    handleImageLoad(e) {
      const index = this.honor.findIndex(item => item.src === e.target.src);
      if (index !== -1) {
        this.$set(this.honor[index], 'loaded', true);
      }
    },
    goTo(index) {
      if (this.isTransitioning) return;

      const originalLength = this.originalHonor.length;
      const totalLength = this.sortedHonor.length;

      // 确保索引在有效范围内
      if (index >= 0 && index < totalLength) {
        this.currentHonorId = this.sortedHonor[index].Id;
        this.resetAutoPlay();
      }
    },
    startAutoPlay() {
      this.clearAutoPlay();
      this.autoPlayInterval = setInterval(() => {
        this.next();
      }, this.autoPlayIntervalTime);
    },
    resetAutoPlay() {
      this.clearAutoPlay();
      this.startAutoPlay();
    },
    clearAutoPlay() {
      if (this.autoPlayInterval) {
        clearInterval(this.autoPlayInterval);
        this.autoPlayInterval = null;
      }
    },
    highlightItem(index) {
      this.highlightedIndex = index;
    },
    resetHighlight() {
      this.highlightedIndex = null;
    },
    handleResize() {
      this.isMobile = window.innerWidth < 768;
      this.itemsPerPage = this.isMobile ? 1 : 3;
    },
    switchTab(index) {
      this.currentTab = index;
      const routePath = index === 0 ? '/Talent' : '/Talent/system';
      if (this.$route.path !== routePath) {
        this.$router.push(routePath).catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err;
        });
      }
    },
    goToHome() {
      this.$router.push('/').catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    },
    goToTalent() {
      if (this.$route.path !== '/Talent') {
        this.$router.push('/Talent').catch(err => {
          if (err.name !== 'NavigationDuplicated') throw err;
        });
      }
      this.currentTab = 0;
    },
    goToJobDetail(locationName) {
      this.$router.push({
        path: '/Talent/JoinDetail',
        query: { location: locationName }
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') throw err;
      });
    },
  },
  created() {
    // 初始化时从原始数据的开始位置开始
    if (this.sortedHonor.length > 0) {
      this.currentHonorId = this.sortedHonor[this.itemsPerPage].Id;
    }
    this.preloadImages();
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize(); // 初始化时调用一次
    this.startAutoPlay();
    this.highlightedIndex = Math.floor(this.itemsPerPage / 2);
  },
  beforeDestroy() {
    this.clearAutoPlay();
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>

<style lang="less" scoped>
@import "@/assets/fontsize/aboutHaiLin.less";  /* ✅ 正确引入变量定义 */

.fade-in {
  animation: fadeIn 0.5s;
}
.cert-container-box{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height:400px;
  max-width: 1400px;
  width: 80%;
  transition: transform 0.5s ease; /* 添加过渡效果 */
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.image-placeholder {
  width: 100%;
  height: 300px;
 /* background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);*/
 /* background-size: 200% 100%;*/
  animation: loading 3s infinite;
}

@keyframes loading {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}
.honor {
  width: 100%;
  align-content: center;
  justify-content: center;
  font-family: 'SourceHanSansCN', sans-serif; /* 尝试使用宋体或类似字体 */
}

.cert-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.cert-item {
  width: 28%;
  /*min-width: 340px;*/
  text-align: left;
  transition: all 0.5s ease; /* 优化过渡效果 */
}

.cert-item.highlight {
  transform: scale(1.1); /* 放大效果 */
}

.cert-item img {

  width: 100%;
  height: auto;
}

.cert-title {

  font-size: @honor-text-fontsize;
  font-weight: @honor-font-weight;
  font-family: "Source Han Sans CN";
  color: rgb(77, 77, 77);
  line-height: @honor-line-height;
  margin: 0.5vw 0;

}

.control-img {
  cursor: pointer;
  margin: 0 1%;
  filter: brightness(0) saturate(100%) invert(57%) sepia(4%) saturate(263%) hue-rotate(175deg)
}
.lastImg {
  position: absolute;
  top:40%;
  left:5%;
  width:calc( 2vw + 20px );
  height:calc( 2vw + 20px );
  max-height: 60px;
  max-width: 60px;

}
.nextImg {
  position: absolute;
  top:40%;
  right:5%;
  width:calc( 2vw + 20px );
  height:calc( 2vw + 20px );
  max-height: 60px;
  max-width: 60px;

}
.cert-container {
  flex-direction: row;
  align-items: center;
  position: relative;
}
.cert-item {
  width: 29%;
  margin: 0.5vw 1vw;
}

@media screen and (max-width: 768px) {
  .cert-container-box{
    justify-content: center;
    align-items: normal;
    height: auto;
  }

  .cert-container {
    flex-direction: column;
    align-items: center;
    position: relative;
  }
  .cert-item {
    width: 65%;
    margin-top: 30px;
    /*min-width: 340px;*/
  }

  .cert-title {
    font-size: @phone-honor-text-fontsize;
    margin: 0.5vw 0;
    text-align: center;
  }
  .lastImg {
    width:6%;
    max-width: 60px;
    max-height: 60px;
    height:auto;
    position: absolute;
    top: calc(25% + 30px);
    left: 5%;
    margin-right: 1vw;
    z-index: 1000;
  }
  .nextImg {
    width:6%;
    max-width: 60px;
    max-height: 60px;
    height:auto;
    margin-left: 1vw;
    position: absolute;
    top: calc(25% + 30px);
    right: 5%;
    z-index: 1000;
  }
}

/* 当正在过渡时禁用过渡效果 */
.cert-container-box.no-transition {
  transition: none;
}
</style>
